import styled from 'styled-components'

export const Wrapper = styled.div`
  .section {
    /* border: 4px dotted purple; */
    height: 100vh;
    margin-top: 4.4rem;
  }
`;